<app-loader *ngIf="isDisabled"></app-loader>